import Packages from '@/views/packages/packages.vue'
import NewPackage from '@/views/packages/new-package.vue'
import EditPackage from '@/views/packages/edit-package.vue'
import { PackagesRouteNames } from '@/router/routes-names'

export const packagesRoutes = [
    {
        path: '/packages',
        name: PackagesRouteNames.LIST,
        component: Packages,
        props: true
    },
    {
        path: '/packages/new',
        name: PackagesRouteNames.NEW,
        component: NewPackage
    },
    {
        path: '/packages/edit/:code',
        name: PackagesRouteNames.EDIT,
        component: EditPackage
    }
]
